import { render, staticRenderFns } from "./SafesportCoordinator.vue?vue&type=template&id=1a7c41f6&scoped=true"
import script from "./SafesportCoordinator.vue?vue&type=script&lang=js"
export * from "./SafesportCoordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7c41f6",
  null
  
)

export default component.exports